//for the 2% of browsers that support modules but not dynamic imports: https://caniuse.com/#feat=es6-module-dynamic-import
import dynamicImportPolyfill from 'dynamic-import-polyfill';
dynamicImportPolyfill.initialize();

import simOrder from './sim_orders/sim-order.svelte';
const app = new simOrder({
	target: document.getElementById('svelte'),
	props: {
	}
});
